import { render, staticRenderFns } from "./RequestTabContent.vue?vue&type=template&id=03035d8e"
import script from "./RequestTabContent.vue?vue&type=script&lang=js"
export * from "./RequestTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports